import { useState, useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
let cache = null;

export const useSiteTexts = () => {
    const [map, setMap] = useState(cache || {});

    useEffect(() => {
        if (cache) return;
        let active = true;
        axios
            .get(`${BACKEND_URL}/api/texts`)
            .then((r) => {
                cache = r.data.texts || {};
                if (active) setMap(cache);
            })
            .catch(() => {});
        return () => {
            active = false;
        };
    }, []);

    return (key, fallback) =>
        map[key] !== undefined && map[key] !== "" ? map[key] : fallback;
};

export const T = ({ k, fallback }) => {
    const txt = useSiteTexts();
    return <>{txt(k, fallback)}</>;
};

export const EditableTitle = ({ k, fallback }) => {
    const txt = useSiteTexts();
    const val = txt(k, fallback);
    const idx = val.indexOf("|");
    if (idx === -1) return <>{val}</>;
    return (
        <>
            {val.slice(0, idx)}
            <span className="text-brand">{val.slice(idx + 1)}</span>
        </>
    );
};
